// convention for constants is
// [App_Name]_[Action]
var PanoViewerConstants: IPanoViewerConstants = {
    PanoCompass: 'PanoCompass',
    Show: 'Show',
    Hide: 'Hide',
    On: 'On',
    Off: 'Off',
    PanoScanSphereColor: 'PanoScanSphereColor',
    PanoImageSphereColor: 'PanoImageSphereColor',
    TagVolumeBoxColor: 'TagVolumeBoxColor',
    UnitMeasurement: 'UnitMeasurement',
    MeasurementColor: 'MeasurementColor',
    BackgroundColor: 'BackgroundColor',
    ZoomSlider: 'ZoomSlider',
    EdgeShader: 'EdgeShader',
    MemoryProfile: 'MemoryProfile',
    MeshResolution: 'MeshResolution',
    CameraTypeExamine: 'CameraExamine',
    CameraTypeUniversal: 'CameraUniversal',
    CameraTypeFly: 'CameraFly',
    CameraType: 'CameraType',
    ShowCrosshair: 'ShowCrosshair',
    RotationSensitivity: 'RotationSensitivity',
    VelocitySensitivity: 'VelocitySensitivity',
    InvertY: 'InvertY',
} as const;


export default PanoViewerConstants;
